module.exports = {"Born1":{"daobanList":[{"title":"1:办理新车上牌一件事","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、车辆所有人有效的居民身份证（影像化资料）","state":"必要"},{"name":"2、机动车整车出厂合格证明（影像化资料）","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx39.json
// module id = 1336
// module chunks = 0